import { useState, useEffect, useRef } from "react";

type SessionData = {
  sessionId: string | null;
  sessionTitle: string | null;
};

const RenameModal = ({
  renameModalProps,
  renameActiveModal,
  setActiveRenameModalHandler,
  renameSessionHandler,
}: {
  renameModalProps: SessionData;
  renameActiveModal: boolean;
  setActiveRenameModalHandler: (prop: boolean) => void;
  renameSessionHandler: (sessionId: string, sessionTitle: string) => void;
}) => {
  const [sessionText, setSessionText] = useState(renameModalProps.sessionTitle);
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    setSessionText(renameModalProps.sessionTitle);
  }, [renameModalProps.sessionTitle]);

  useEffect(() => {
    if (renameActiveModal) {
      dialogRef.current?.showModal();
    } else {
      dialogRef.current?.close();
    }
  }, [renameActiveModal]);

  const handleRename = (e: React.FormEvent) => {
    e.preventDefault();
    if (sessionText?.trim()) {
      setActiveRenameModalHandler(false);
      renameSessionHandler(
        renameModalProps.sessionId || "",
        sessionText.trim()
      );
    }
  };

  const handleClose = () => {
    setActiveRenameModalHandler(false);
  };

  return (
    <dialog ref={dialogRef} className="modal" onClose={handleClose}>
      <div className="modal-box">
        <h3 className="text-lg font-bold">Rename Project</h3>
        
        <form onSubmit={handleRename} className="py-4">
          <input
            type="text"
            value={sessionText || ""}
            onChange={(e) => setSessionText(e.target.value)}
            className="input input-bordered w-full focus:outline-none"
            placeholder="Enter project name"
            autoFocus
          />
          
          <div className="modal-action">
            <button
              type="button"
              className="btn"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!sessionText?.trim()}
            >
              Rename
            </button>
          </div>
        </form>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button type="button" onClick={handleClose}>close</button>
      </form>
    </dialog>
  );
};

export default RenameModal;
